import { Link } from 'react-router-dom';
import { AnimatedSection } from '../components/AnimatedSection';

const RACING_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/36ckvv9u_WhatsApp%20Image%202026-03-19%20at%2018.38.24-2.jpeg";
const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/96oguhbo_WhatsApp%20Image%202026-03-19%20at%2018.38.24.jpeg";

const ROSS_TESTIMONIAL = `I'm performing at the best I've ever performed and it doesn't feel forced. There's a calmness now that I didn't have before. I'm enjoying my driving again… every bend, every apex, every overtake.

The biggest shift has been stepping away from the kind of thinking that used to get in the way. Once that dropped, everything became clearer — decisions, reactions, everything. There's less noise, more trust, and a simplicity to how I operate now that I've never experienced before.

It's not just changed how I perform — it's changed how I communicate too. With my team, in my personal relationships, and even with myself. There's more clarity, more honesty, and less interference across the board.

Performance has improved and so has how I feel. I feel lighter, calmer, more in control… and there's a direct correlation between that and how I perform. It's hard to fully explain, but something has shifted in a big way over the last year.

This isn't about trying harder — it's about seeing differently. And that's made all the difference.`;

export const TheStable = () => {
  return (
    <div data-testid="the-stable-page" className="bg-[#050505]">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-end pb-12 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Ross Gunn"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent" />
        </div>
        
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 w-full">
          <AnimatedSection>
            <p className="caption-text mb-6">Our Clients</p>
            <h1 className="heading-large">Exceptional Individuals</h1>
          </AnimatedSection>
        </div>
      </section>

      {/* Introduction */}
      <section className="section-padding pt-16">
        <div className="max-w-[900px] mx-auto">
          <AnimatedSection>
            <p className="body-large mb-8">
              Paragon works with a small number of exceptional individuals.
            </p>
            <p className="body-text mb-8">
              Every client relationship is fully confidential.
            </p>
            <p className="body-text">
              However, some clients choose to publicly share their experience of this work.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Featured Quote Header */}
      <section className="section-padding pb-8">
        <div className="max-w-[900px] mx-auto text-center">
          <AnimatedSection>
            <p className="text-white font-['Playfair_Display'] text-2xl md:text-4xl italic leading-relaxed mb-6">
              "I'm performing at the best I've ever performed."
            </p>
            <p className="text-[#888] text-lg">
              Ross Gunn, Aston Martin WEC Driver, IMSA, F1 Mercedes Simulator
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Ross Gunn Feature */}
      <section data-testid="ross-gunn-section" className="section-padding pt-8 bg-[#0A0A0A]">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            <AnimatedSection direction="right">
              <div className="relative">
                <img
                  src={RACING_IMAGE}
                  alt="Ross Gunn - Racing Environment"
                  className="w-full aspect-[4/3] object-cover" />

                <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/50 to-transparent !bg-[rgba(0,0,0,0.45)]" />
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.2}>
              <div className="lg:pl-8">
                <p className="caption-text mb-4">Featured Client</p>
                <h2 className="text-white font-['Playfair_Display'] text-3xl md:text-4xl mb-2">
                  Ross Gunn
                </h2>
                <p className="text-[#aaa] text-lg mb-8">
                  Aston Martin WEC Driver, IMSA, F1 Mercedes Simulator
                </p>
                
                <div className="divider mb-8" />
                
                <div className="space-y-6">
                  {ROSS_TESTIMONIAL.split('\n\n').map((paragraph, index) =>
                  <p key={index} className="body-text leading-relaxed">
                      {paragraph}
                    </p>
                  )}
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Confidentiality Note */}
      <section className="section-padding">
        <div className="max-w-[800px] mx-auto text-center">
          <AnimatedSection>
            <div className="glass-card">
              <p className="caption-text mb-6">Confidentiality</p>
              <p className="text-white font-['Playfair_Display'] text-xl md:text-2xl leading-relaxed">
                All other Paragon client relationships<br />
                remain strictly confidential.
              </p>
              <div className="divider mx-auto my-8" />
              <p className="text-[#666] text-sm">
                We believe in the power of privacy.<br />
                True transformation happens in spaces of trust.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[600px] mx-auto text-center">
          <AnimatedSection>
            <p className="body-text mb-8">
              Join our exclusive community of performers.
            </p>
            <Link to="/apply" data-testid="stable-apply-btn" className="btn-primary">
              Begin the Conversation
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>);

};